import {getTradeTagsCollectionPath, type TradeTagDb} from '@cp/model';
import {collection, CollectionReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export function getTradeTagsCollection(uid: string): CollectionReference<TradeTagDb> {
  return collection(firebaseFirestore, getTradeTagsCollectionPath(uid)) as CollectionReference<TradeTagDb>;
}
